import axios from 'axios';

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
  async config => {
    const token = localStorage.getItem('serviceToken');
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

axiosServices.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response.status === 401 &&
      !window.location.href.includes('/signin')
    ) {
      window.location = '/signin';
    }

    return Promise.reject(
      (error.response && error.response.data) || 'Wrong Services',
    );
  },
);

export default axiosServices;

export const fetcher = async args => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async args => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosServices.post(url, { ...config });

  return res.data;
};
